import {
  Heart, MapPin, Car, Home, Zap, Utensils, Wrench, Package,
  Droplets, Thermometer, Cross, Users, Warehouse, Sparkles,
  Fuel, PlugZap, Mail, Landmark, Pill, Building2, Shield,
  Flame, Bath, ShoppingCart, BookOpen, Church
} from 'lucide-react';

export const API = process.env.REACT_APP_BACKEND_URL + '/api';

export const DARK_TILE_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
export const TILE_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

export const CATEGORIES = [
  { value: 'food', label: 'Food', icon: Utensils, color: 'text-orange-400' },
  { value: 'transport', label: 'Transport', icon: Car, color: 'text-blue-400' },
  { value: 'shelter', label: 'Shelter', icon: Home, color: 'text-purple-400' },
  { value: 'skills', label: 'Skills', icon: Wrench, color: 'text-cyan-400' },
  { value: 'supplies', label: 'Supplies', icon: Package, color: 'text-green-400' },
  { value: 'energy', label: 'Energy', icon: Zap, color: 'text-yellow-400' },
  { value: 'other', label: 'Other', icon: Heart, color: 'text-pink-400' },
];

export const RESOURCE_CATEGORIES = [
  { value: 'water', label: 'Water Point' },
  { value: 'food', label: 'Food Bank / Kitchen' },
  { value: 'shelter', label: 'Shelter / Warm Bank' },
  { value: 'charging', label: 'Charging Station' },
  { value: 'medical', label: 'Medical / First Aid' },
  { value: 'warmth', label: 'Warm Space' },
  { value: 'community', label: 'Community Hub' },
  { value: 'bunker', label: 'Bunker / Shelter' },
  { value: 'skate_spots', label: 'Skate Spot' },
  { value: 'petrol', label: 'Petrol Station' },
  { value: 'ev_charging', label: 'EV Charging' },
  { value: 'post_office', label: 'Post Office' },
  { value: 'bank', label: 'Bank / ATM' },
  { value: 'pharmacy', label: 'Pharmacy' },
  { value: 'hospital', label: 'Hospital / A&E' },
  { value: 'police', label: 'Police Station' },
  { value: 'fire_station', label: 'Fire Station' },
  { value: 'toilets', label: 'Public Toilet' },
  { value: 'supermarket', label: 'Supermarket' },
  { value: 'library', label: 'Library' },
  { value: 'worship', label: 'Place of Worship' },
  { value: 'other', label: 'Other' },
];

export const getCatIcon = (cat) => {
  const found = CATEGORIES.find(c => c.value === cat);
  return found || CATEGORIES[6];
};

export const MARKER_COLORS = {
  water: '#38bdf8',
  food: '#e879a8',
  shelter: '#a855f7',
  charging: '#38bdf8',
  medical: '#f472b6',
  warmth: '#c084fc',
  community: '#818cf8',
  bunker: '#94a3b8',
  skate_spots: '#34d399',
  petrol: '#f59e0b',
  ev_charging: '#22c55e',
  post_office: '#ef4444',
  bank: '#3b82f6',
  pharmacy: '#10b981',
  hospital: '#dc2626',
  police: '#6366f1',
  fire_station: '#f97316',
  toilets: '#8b5cf6',
  supermarket: '#06b6d4',
  library: '#a78bfa',
  worship: '#d97706',
  other: '#94a3b8',
};

export const ICON_FILTERS = [
  { value: 'food', label: 'Food', icon: Utensils, color: '#e879a8' },
  { value: 'warmth', label: 'Warmth', icon: Thermometer, color: '#c084fc' },
  { value: 'charging', label: 'Charging', icon: Zap, color: '#38bdf8' },
  { value: 'water', label: 'Water', icon: Droplets, color: '#38bdf8' },
  { value: 'medical', label: 'Medical', icon: Cross, color: '#f472b6' },
  { value: 'shelter', label: 'Shelter', icon: Home, color: '#a855f7' },
  { value: 'community', label: 'Community', icon: Users, color: '#818cf8' },
  { value: 'bunker', label: 'Bunker', icon: Warehouse, color: '#94a3b8' },
  { value: 'skate_spots', label: 'Sk8 Spots', icon: Sparkles, color: '#34d399' },
  { value: 'petrol', label: 'Petrol', icon: Fuel, color: '#f59e0b' },
  { value: 'ev_charging', label: 'EV Charging', icon: PlugZap, color: '#22c55e' },
  { value: 'post_office', label: 'Post Office', icon: Mail, color: '#ef4444' },
  { value: 'bank', label: 'Bank / ATM', icon: Landmark, color: '#3b82f6' },
  { value: 'pharmacy', label: 'Pharmacy', icon: Pill, color: '#10b981' },
  { value: 'hospital', label: 'Hospital', icon: Building2, color: '#dc2626' },
  { value: 'police', label: 'Police', icon: Shield, color: '#6366f1' },
  { value: 'fire_station', label: 'Fire Station', icon: Flame, color: '#f97316' },
  { value: 'toilets', label: 'Toilets', icon: Bath, color: '#8b5cf6' },
  { value: 'supermarket', label: 'Supermarket', icon: ShoppingCart, color: '#06b6d4' },
  { value: 'library', label: 'Library', icon: BookOpen, color: '#a78bfa' },
  { value: 'worship', label: 'Worship', icon: Church, color: '#d97706' },
];

export const POSTIT_COLORS = [
  '/assets/postit/pink.webp',
  '/assets/postit/yellow.webp',
  '/assets/postit/green.webp',
  '/assets/postit/blue.webp',
];

export const RADIUS_OPTIONS = [
  { value: 1, label: '1 mi' },
  { value: 5, label: '5 mi' },
  { value: 20, label: '20 mi' },
  { value: 50, label: '50 mi' },
  { value: 0, label: 'All UK' },
];
